// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0f56a522","455":"f6034d4c","977":"ed6e441c"}[chunkId] + ".chunk.js";
};